import React from "react";
import { useState, useMemo, useEffect } from "react";
import ListTable from "../utils/Table";
import Export from "../utils/Export";
import {
  customer_delete,
  customer_update,
  all_customer_list,
  customer_create,
} from "./../../actions/customer";
import { useDispatch, useSelector } from "react-redux";
import Form from "../utils/Form";
import { FormStructure } from "./FormStructure";
import ViewChange from "../utils/ViewChange";
import { useLocation, useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";

export default function Customer() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView] = useState(location?.state?.view || "view_all");
  const [form, setForm] = useState(
    (location?.state?.form && JSON.parse(location?.state?.form)) || {}
  );
  const [isSameAdd, setIsSameAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const tempFormStruct = FormStructure(isEdit);
  const user = useSelector((state) => state.layout.profile);

  const [formStructure, setFormStructure] = useState([...tempFormStruct]);

  useMemo(() => {
    if (user) {
      const data = new FormData();
      data.append("id", user?.id);
      dispatch(all_customer_list(data));
    }
  }, [user]);
  const [tableData, setTableData] = useState({
    tableTitle: "Parties",
    deleteRecord: customer_delete,
    updateRecord: customer_update,
    onDeleteText: "Are you sure want to delete this customer?",
    customisedStatusUpdateMessage: true,
    onActiveText: "Are you sure you want to activate this customer?",
    onInactiveText: [
      "Are you sure you want to inactivate this customer? ",
      "The customer will no longer be logged into the system once you inactivate it.",
    ],
    tableHead: [
      {
        id: "name",
        label: "Name",
        link: "/Customer/CustomerDetail/CustomerDetail",
        // subText: "GST",
        color: "var(--gradientColor2)",
      },
      {
        id: "email",
        label: "Customer Info",
        subText: "mobileNumber",
      },
      {
        id: "city",
        label: "City",
        subText: "pincode",
      },
      {
        id: "state",
        label: "State",
      },

      {
        id: "created_at",
        label: "Date",
      },
      {
        id: "edit",
        label: "Update",
      },
    ],
    tableBody: [],
    filterColumn: [
      // {
      //   id: "1",
      //   title: "Plan Type",
      //   name: "subscription",
      //   options: ["FREE", "TVOD", "SVOD"],
      // },
      // {
      //   id: "1",
      //   title: "Login By",
      //   name: "socialType1",
      //   options: ["Gmail", "Mobile"],
      // },
    ],
    isDateRangeFilter: "created_at",
  });

  const formTitle = isEdit ? "Edit Partie" : "Create Partie";
  const customers = useSelector((state) => state.customers.customers);

  const message = useSelector((state) => state.layout.message);
  useMemo(() => {
    if (isEdit) {
      setView("create_new");
    } else {
      setView("view_all");
      setForm({
        sequence:
          Number(
            tableData.tableBody[tableData.tableBody.length - 1]?.["sequence"]
          ) + 1,
      });
    }
  }, [isEdit]);
  const path = location?.pathname.split("/")[2];
  useEffect(() => {
    setView(path != "Customer" ? "create_new" : "view_all");
    setForm(
      (location?.state?.form && JSON.parse(location?.state?.form)) || {
        sequence:
          Number(
            tableData.tableBody[tableData.tableBody.length - 1]?.["sequence"]
          ) + 1,
      }
    );
    setIsEdit(path == "EditCustomer");
  }, [location]);

  // Example state code map (India)
  // Indian States & Union Territories GST Code Map
  const stateCodeMap = {
    "Andhra Pradesh": "28",
    "Arunachal Pradesh": "12",
    Assam: "18",
    Bihar: "10",
    Chhattisgarh: "22",
    Goa: "30",
    Gujarat: "24",
    Haryana: "06",
    "Himachal Pradesh": "02",
    Jharkhand: "20",
    Karnataka: "29",
    Kerala: "32",
    "Madhya Pradesh": "23",
    Maharashtra: "27",
    Manipur: "14",
    Meghalaya: "17",
    Mizoram: "15",
    Nagaland: "13",
    Odisha: "21",
    Punjab: "03",
    Rajasthan: "08",
    Sikkim: "11",
    "Tamil Nadu": "33",
    Telangana: "36",
    Tripura: "16",
    "Uttar Pradesh": "09",
    Uttarakhand: "05",
    "West Bengal": "19",
    Delhi: "07",
    "Jammu and Kashmir": "01",
    Ladakh: "38",
    Puducherry: "34",
    "Andaman and Nicobar Islands": "35",
    Chandigarh: "04",
    "Dadra and Nagar Haveli and Daman and Diu": "26",
    Lakshadweep: "31",
  };

  // useEffect(() => {
  //   dispatch(all_customer_list());
  // }, [message]);
  useMemo(() => {
    if (customers?.statuscode == 200) {
      const temp = tableData;
      temp.tableBody = customers?.data.map((ele) => ({
        ...ele,
      }));
      setTableData({ ...temp });
    }
  }, [customers]);

  // useMemo(()=>{
  // const temp = formStructure
  // temp[5]["options"] = Country.getAllCountries().map(
  // 	(ele) => ele?.name)
  // setFormStructure([...temp])
  // },[Country])

  // console.log(selectCountry,"newLes")
  useMemo(() => {
    const temp = formStructure;
    temp[4]["options"] = State.getStatesOfCountry("IN").map((ele) => ele?.name);
    temp[13]["options"] = State.getStatesOfCountry("IN").map(
      (ele) => ele?.name
    );
    setFormStructure([...temp]);
  }, [State]);
  useMemo(() => {
    const temp = formStructure;
    const StateName = State.getStatesOfCountry("IN")
      .map((ele) => ele?.name == form?.state && ele?.isoCode)
      .filter((e) => e)
      .toString();
    console.log(StateName, "newSelect");
    const stateCode = stateCodeMap[form?.state];
    console.log(stateCode); // Output: "03"
    setForm({ ...form, state_code: stateCode });
    temp[6]["options"] = City.getCitiesOfState("IN", StateName).map(
      (ele) => ele?.name
    );
    setFormStructure([...temp]);
  }, [form?.state, City]);
  useMemo(() => {
    const temp = formStructure;
    const StateName = State.getStatesOfCountry("IN")
      .map((ele) => ele?.name == form?.delivery_state && ele?.isoCode)
      .filter((e) => e)
      .toString();
    console.log(StateName, "newSelect");
    const stateCode = stateCodeMap[form?.delivery_state];
    console.log(stateCode); // Output: "03"
    setForm({ ...form, delivery_state_code: stateCode });
    temp[15]["options"] = City.getCitiesOfState("IN", StateName).map(
      (ele) => ele?.name
    );
    setFormStructure([...temp]);
  }, [form?.delivery_state, City]);

  const setAddress = (event) => {
    setIsSameAdd(event.target.checked);
  };

  console.log(isSameAdd, "New Feature Check");
  useMemo(() => {
    const temp = formStructure;
    temp[12]["handleChanges"] = setAddress;
    temp[12]["baseValue"] = isSameAdd;
    setFormStructure([...temp]);
  }, [formStructure[12]]);

  useEffect(() => {
    console.log(isSameAdd, "Hiii Parth");
    if (isSameAdd) {
      const temp = formStructure;
      temp[13]["disabled"] = true;
      temp[14]["disabled"] = true;
      temp[15]["disabled"] = true;
      temp[16]["disabled"] = true;
      temp[17]["disabled"] = true;
      setFormStructure([...temp]);
      setForm({
        ...form,
        delivery_state: form?.state,
        delivery_state_code: form?.state_code,
        delivery_city: form?.city,
        delivery_address: form?.address,
        delivery_pincode: form?.pincode,
      });
    } else {
      setForm({
        ...form,
        delivery_state: "",
        delivery_state_code: "",
        delivery_city: "",
        delivery_address: "",
        delivery_pincode: "",
      });
      const temp = formStructure;
      temp[13]["disabled"] = false;
      temp[14]["disabled"] = false;
      temp[15]["disabled"] = false;
      temp[16]["disabled"] = false;
      temp[17]["disabled"] = false;
      setFormStructure([...temp]);
    }
  }, [isSameAdd]);
  useMemo(() => {
    if (isEdit) {
      const temp = formStructure;
      temp[12]["display"] = "none";
      setFormStructure([...temp])
    }else{
      const temp = formStructure;
      temp[12]["display"] = "block";
      setFormStructure([...temp])
    }
  }, [isEdit]);
    console.log(view ,"isView123")
  useMemo(()=>{
    if(view == "view_all"){
      setIsEdit(false)
    }
  },[view])
  console.log(isEdit, "3333");

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData();
    const form_changes = form;
    form_changes["created_by"] = user?.id;
    setForm({
      ...form_changes,
    });
    Object.keys(form).map((key) => data.append(key, form?.[key]));

    if (isEdit) {
      dispatch(customer_update(data));
    } else {
      dispatch(customer_create(data));
    }
  };
  useMemo(() => {
    if (message?.statuscode == 200) {
      setIsEdit(false);

      setForm({});
      setTimeout(() => {
        const data = new FormData();
        data.append("id", user?.id);
        dispatch(all_customer_list(data));
        navigate("/Customer/Customer", { state: { view: "view_all" } });
        setView("view_all");
      }, 1000);
    } else {
      setForm({ ...form });
    }
  }, [message]);
  return (
    <>
      <ViewChange
        setView={setView}
        setIsEdit={setIsEdit}
        view={view}
        isEdit={isEdit}
        create_new={"/Customer/CreateCustomer"}
        view_all={"/Customer/Customer"}
        form={form}
      />

      {view == "create_new" && (
        <Form
          handleSubmit={handleSubmit}
          formStructure={formStructure}
          formTitle={formTitle}
          key={"Form"}
          setForm={setForm}
          form={form}
          tableData={tableData}
          setTableData={setTableData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}

      {view == "view_all" && (
        <ListTable
          tableData={tableData}
          key={"ListTable"}
          setForm={setForm}
          setTableData={setTableData}
          setIsEdit={setIsEdit}
          create_new={"/Customer/EditCustomer"}
        />
      )}
    </>
  );
}
